import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CookiesState } from './cookies.state';
import {
  AcceptAllCookies,
  ChangeCookiesStep,
  CloseCookiesDialog,
  ConfirmPreferences,
  InitializeCookiesFromStorage,
  OpenCookiesDialog,
  RejectCookies,
  SetCookieConsent,
} from './cookies.actions';
import { CookieConsent } from 'src/app/_core/state/dialogs/cookies/service/models/cookie-consent';
import { CookieStep } from './service/models/cookie-step.model';

@Injectable({
  providedIn: 'root',
})
export class CookiesFacade {
  private readonly store = inject(Store);

  @Select(CookiesState.isOpen) isOpen$: Observable<boolean>;
  @Select(CookiesState.requiredCookies) requiredCookies$: Observable<CookieConsent[]>;
  @Select(CookiesState.optionalCookies) optionalCookies$: Observable<CookieConsent[]>;
  @Select(CookiesState.step) step$: Observable<CookieStep>;
  @Select(CookiesState.hasConsent) hasConsent$: Observable<boolean>;

  initializeCookiesFromStorage() {
    this.store.dispatch(new InitializeCookiesFromStorage());
  }

  openCookiesDialog() {
    this.store.dispatch(new OpenCookiesDialog());
  }

  closeCookiesDialog() {
    this.store.dispatch(new CloseCookiesDialog());
  }

  setCookieConsent(cookieId: string, accepted: boolean) {
    this.store.dispatch(new SetCookieConsent(cookieId, accepted));
  }

  acceptAllCookies() {
    this.store.dispatch(new AcceptAllCookies());
  }

  rejectCookies() {
    this.store.dispatch(new RejectCookies());
  }

  confirmPreferences() {
    this.store.dispatch(new ConfirmPreferences());
  }

  changeStep(step: CookieStep) {
    this.store.dispatch(new ChangeCookiesStep(step));
  }
}
